var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCamera = function SvgCamera(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-15686.36 -5859.762 27.721 22.792",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1233",
    transform: "translate(-15695.36 -6828.414)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1346",
    d: "M15.164,965.362a1,1,0,0,0-.828.51l-1.29,2.57H8.08A3.094,3.094,0,0,0,5,971.522v13.552a3.094,3.094,0,0,0,3.08,3.08H29.64a3.094,3.094,0,0,0,3.08-3.08V971.522a3.094,3.094,0,0,0-3.08-3.08H24.674l-1.29-2.57a.945.945,0,0,0-.828-.51Zm.578,1.848h6.237l1.29,2.57a.945.945,0,0,0,.828.51H29.64a1.21,1.21,0,0,1,1.232,1.232v13.552a1.21,1.21,0,0,1-1.232,1.232H8.08a1.21,1.21,0,0,1-1.232-1.232V971.522A1.21,1.21,0,0,1,8.08,970.29h5.544a.945.945,0,0,0,.828-.51Zm3.119,4.62a6.468,6.468,0,1,0,6.468,6.468A6.482,6.482,0,0,0,18.86,971.83Zm0,1.848a4.62,4.62,0,1,1-4.62,4.62A4.606,4.606,0,0,1,18.86,973.678Z",
    transform: "translate(4 3.289)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCamera, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/camera.d48164dc.svg";
export { ForwardRef as ReactComponent };